import { splitPath } from "@/store/helpers";
import { week_days } from "@/mixins/days.mixin";
import {
  G_USER_TASKS_CACHE,
  G_USER_TASK_DELETE,
  G_USER_TASK_UPDATE,
} from "@/store/modules/helpers/action.type";
import {
  G_ALL_USER_TASKS,
  G_DEFAULT_GROUP
} from "@/store/modules/helpers/getter.type";
import { mapGetters } from "vuex";

export default {
  data: () => ({
    // This is a hack to trigger an update in `task_loading`.
    __task_loading_ticker: 1,
    __task_loading: new Set([]),
  }),
  computed: {
    task_loading() {
      return this.$data.__task_loading_ticker && this.$data.__task_loading;
    },
    ...mapGetters({
      "tasks_all": G_ALL_USER_TASKS,
    }),
  },
  methods: {
    task_set_loading(task) {
      let task_id;
      if (typeof task === "object") task_id = task.id;
      else task_id = task;

      this.$data.__task_loading.add(task_id);
      this.$data.__task_loading_ticker += 1;
    },
    task_set_loaded(task) {
      let task_id;
      if (typeof task === "object") task_id = task.id;
      else task_id = task;

      if (this.$data.__task_loading.delete(task_id))
        this.$data.__task_loading_ticker -= 1;
    },
    task_cache_all() {
      return this.$store.dispatch(G_USER_TASKS_CACHE, { watch: true });
    },
    task_get_category_name(task) {
      // TODO: Actually there could be **many** category names, but this is a start
      const parts = splitPath(task.associations[0].text);
      return parts[0] ?? "";
    },
    task_get_item_name(task) {
      // TODO: Actually there could be **many** item names, but this is a start
      const parts = splitPath(task.associations[0].text);
      return parts[1] ?? "";
    },
    task_get_week_days(task) {
      if (!task.is_periodic) return 0;

      // Support deprecated day format.
      if (typeof task.week_days === "object") {
        // Encode week days into a number.
        const encoded = task.week_days
          .map(d => 1 << week_days.findIndex(wd => wd === d))
          .reduce((acc, d) => acc | d, 0);

        // NOTE: This is ok because all code handles both week days formats, so
        // nothing should break because of this.
        task.week_days = encoded;
        return encoded;
      } else {
        return task.week_days;
      }
    },
    task_get_next_date(task) {
      if (!task.is_periodic) {
        const [year, month, day] = task.date.split("-").map(n => parseInt(n));
        const hours = Math.floor(task.time / 60);
        const minutes = task.time % 60;
        return new Date(year, month, day, hours, minutes, 0, 0);
      } else {
        const brasilia_now = getTimeWithOffset(-3);
        const today = brasilia_now.getDay();

        let min_offset = -1;

        for (let day = 0; day < 7; day++) {
          // If `day` is not a selected day for the task, skip it.
          if (typeof task.week_days === "object" && !task.week_days.includes(week_days[day]))
            continue;

          if (typeof task.week_days === "number" && !((task.week_days >> day) & 1))
            continue;
          
          let offset = day - today;
          if (offset < 0) offset += 7;

          if (min_offset < 0 || min_offset > offset) {
            min_offset = offset;
          }
        }

        const next_date = new Date(brasilia_now);
        next_date.setDate(brasilia_now.getDate() + min_offset);

        const year  = next_date.getFullYear();
        const month = next_date.getMonth();
        const date  = next_date.getDate();
        const hours = Math.floor(task.time / 60);
        const minutes = task.time % 60;

        return new Date(year, month, date, hours, minutes, 0, 0);
      }
    },
    task_delete(task) {
      this.task_set_loading(task);
      this.$store.dispatch(G_USER_TASK_DELETE, task.id)
        .then(() => {
          // Just re-download everything.
          this.task_cache_all().then(() => this.task_set_loaded(task));
        });
    },
    task_add(query_path, suggested_title) {
      let query = query_path ? { path: query_path } : {};
      if (this.$route.query.path)
        query.path = this.$route.query.path;
      
      const route = {
        name: "CreateTask",
        params: {
          group_id: this.group_id,
          context_id: this.context_id,
        },
        query,
      };

      if (suggested_title)
        route.params = { suggested_title };

      this.$router.push(route);
    },
    task_day_update(task) {
      return async change => {
        // Toggles the bit in `change` position.
        task.week_days = task.week_days ^ (1 << change);

        this.task_set_loading(task.id);

        await this.$store.dispatch(G_USER_TASK_UPDATE, {
          task: {
            id: task.id,
            week_days: task.week_days,
          },
          group: this.$store.getters[G_DEFAULT_GROUP],
        });

        this.task_set_loaded(task.id);
      }
    }
  },
};

// Source: https://stackoverflow.com/questions/8207655/get-time-of-specific-timezone
function getTimeWithOffset(offset) {
  // create Date object for current location
  var d = new Date();

  // convert to msec
  // subtract local time zone offset
  // get UTC time in msec
  var utc = d.getTime() + (d.getTimezoneOffset() * 60000);

  // create new Date object for different city
  // using supplied offset
  var nd = new Date(utc + (3600000*offset));

  return nd;
}
